export enum MATERIAL_ABILITY {
  // 全能模式
  BASIC = 'basic_generation',

  // 图片转风格
  DRAFT = 'draft_generation',

  // 图片转风格进阶版
  DRAFT_PRO = 'transform_style',

  // 图裂变
  IMAGE = 'image_generation',

  // 图裂变进阶
  IMAGE_PRO = 'image_generation_pro',

  // 文生图
  TEXT = 'text_generation',

  // 文生图进阶
  TEXT_PRO = 'text_generation_pro',

  // 艺术字生成
  ART_WORD = 'art_word',

  // 无缝
  TILED = 'tiled',
  TILING = 'tiling',

  // 免抠
  TRANSPARENT = 'transparent',

  // 标题提取
  TITLE = 'title',

  // 数据采集
  CRAWLING = 'crawling',

  // 图案裁剪
  DETECT = 'detect',

  // 局部改图
  PART_REPLACE = 'part_replace',

  // pod
  POD = 'pod',

  // 商品图换背景
  BG = 'change_background',

  // AI模特
  MODEL = 'model',

  // AI 试衣
  FITTING = 'fitting',

  WORKFLOW = 'workflow',

  // 商品套图
  MOCKUP = 'mockup',

  // 姿势控制生图
  POSE = 'pose_generation',

  // 素材生成首页
  EDITOR = 'editor',

  // 一键抠图
  MATTING = 'matting',

  // 图案转形状
  MULTI_SIZE = 'multi_size',

  STYLE_REFERENCE = 'style_reference',

  VIDEO = 'video',

  // 批量抠图
  BATCH_MATTING = 'batch_matting',

  // 智能擦除
  ERASER = 'remove',

  // 画面拓展
  EXPAND = 'expand',

  // 线稿提取
  LINE = 'line_drawing_extraction',

  // 智能替换
  REPLACE = 'replace',

  // 无损放大
  UPSCALE = 'upscale',

  // 图像裁剪
  CROP = 'crop',

  // 脸部修复
  FACE = 'face',

  // 手部修复
  HAND = 'hand',

  // 换色
  COLOR_CHANGE = 'color_change',

  // 转 SVG
  SVG = 'svg',

  // 无缝排版
  STITCHING = 'stitching',

  // 印花图提取（图转印刷图）
  IMAGE_TO_PRINT = 'image_2_print',

  // 侵权风险过滤
  TORT = 'tort',

  // 印花合成
  PRINTING_COMPOSITING = 'print_compositing',

  // 风格转绘
  REDRAW = 'redraw',

  // 裁剪压缩
  IMAGE_PROCESSING = 'image_processing',

  // 四方连续图
  SEAMLESS = 'seamless',

  // 去水印
  WATERMARK = 'watermark',

  // 批量编辑
  BATCH_EDITOR = 'editor',

  // 去水印
  BATCH_WATERMARK = 'batch_watermark',

  // 裁剪压缩
  BATCH_IMAGE_PROCESSING = 'batch_image_processing',

  // 扩图
  BATCH_EXPAND = 'batch_expand',

  // 纯色扩图
  BG_EXPAND = 'bg_expand',

  // 生产图
  CUT_PIECES = 'cut_pieces',

  // 元素融合
  BLEND = 'blend',

  // 多联画
  POLYPTYCH = 'polyptych',

  // AI试衣
  DRESS = 'dress',

  // 生产图
  PRODUCTION = 'production_compositing',

  // DIY图片合成
  DIY_COMPOSITING = 'diy_compositing',

  // DIY履约图合成
  DIY_FULFILLMENT = 'diy_fulfillment',

  // 宠物换装
  PET_DRESSUP = 'pet_dressup',
}

// 素材生成下能力
export const MATERIAL_CREATE_ABILITIES = [
  MATERIAL_ABILITY.IMAGE,
  MATERIAL_ABILITY.IMAGE_PRO,
  MATERIAL_ABILITY.TEXT,
  MATERIAL_ABILITY.TEXT_PRO,
  MATERIAL_ABILITY.BASIC,

  MATERIAL_ABILITY.DRAFT,
  MATERIAL_ABILITY.DRAFT_PRO,
  MATERIAL_ABILITY.TILED,
  MATERIAL_ABILITY.TRANSPARENT,

  MATERIAL_ABILITY.POD,

  MATERIAL_ABILITY.POSE,
  // MATERIAL_ABILITY.ART_WORD,
];

// 效果生成下能力
export const MATERIAL_COMPOSITE_ABILITIES = [
  MATERIAL_ABILITY.BG,
  MATERIAL_ABILITY.MODEL,
  MATERIAL_ABILITY.FITTING,
  MATERIAL_ABILITY.MOCKUP,
];

// 素材编辑下能力
export const MATERIAL_EDIT_ABILITIES = [
  MATERIAL_ABILITY.EDITOR,
  MATERIAL_ABILITY.MATTING,
  // MATERIAL_ABILITY.BATCH_MATTING,
  MATERIAL_ABILITY.EXPAND,
  MATERIAL_ABILITY.REPLACE,
  MATERIAL_ABILITY.ERASER,
  MATERIAL_ABILITY.UPSCALE,
  MATERIAL_ABILITY.LINE,
  MATERIAL_ABILITY.CROP,
  MATERIAL_ABILITY.FACE,
  MATERIAL_ABILITY.HAND,
  MATERIAL_ABILITY.COLOR_CHANGE,
  // MATERIAL_ABILITY.SVG,
  MATERIAL_ABILITY.STITCHING,
];

export const MATERIAL_ABILITY_NAMES = {
  [MATERIAL_ABILITY.IMAGE]: '图裂变',
  [MATERIAL_ABILITY.IMAGE_PRO]: '图裂变（进阶）',
  [MATERIAL_ABILITY.TEXT]: '文生图',
  [MATERIAL_ABILITY.TEXT_PRO]: '文生图（进阶）',
  [MATERIAL_ABILITY.BASIC]: '全能模式',
  [MATERIAL_ABILITY.DRAFT]: '图片转风格',
  [MATERIAL_ABILITY.DRAFT_PRO]: '图片转风格（进阶）',
  [MATERIAL_ABILITY.PART_REPLACE]: '局部改图',

  [MATERIAL_ABILITY.CRAWLING]: '数据采集',
  [MATERIAL_ABILITY.TILED]: '无缝素材生成',
  [MATERIAL_ABILITY.TILING]: '四方连续图拼接',
  [MATERIAL_ABILITY.BG_EXPAND]: '扩图',

  [MATERIAL_ABILITY.TRANSPARENT]: '免抠元素生成',

  [MATERIAL_ABILITY.POD]: 'POD素材生成',
  [MATERIAL_ABILITY.MULTI_SIZE]: '尺寸延展',
  [MATERIAL_ABILITY.STYLE_REFERENCE]: '风格参考',

  [MATERIAL_ABILITY.POSE]: '姿势生图',
  [MATERIAL_ABILITY.DETECT]: '图像裁剪',
  [MATERIAL_ABILITY.TITLE]: '标题提取',
  [MATERIAL_ABILITY.REDRAW]: '风格转绘',
  [MATERIAL_ABILITY.SEAMLESS]: '四方连续图',
  [MATERIAL_ABILITY.IMAGE_PROCESSING]: '商品裁剪压缩',
  [MATERIAL_ABILITY.VIDEO]: '视频生成',
  [MATERIAL_ABILITY.CUT_PIECES]: '生产图合成',
  [MATERIAL_ABILITY.PRODUCTION]: '设为生产图',
  // [MATERIAL_ABILITY.ART_WORD]: '艺术字生成',

  [MATERIAL_ABILITY.BG]: '商品图换背景',
  [MATERIAL_ABILITY.MODEL]: 'AI模特图',
  [MATERIAL_ABILITY.FITTING]: 'AI试衣',
  [MATERIAL_ABILITY.MOCKUP]: '商品套图',

  [MATERIAL_ABILITY.MATTING]: '一键抠图',
  [MATERIAL_ABILITY.BATCH_MATTING]: '一键抠图｜批量',
  [MATERIAL_ABILITY.EXPAND]: '画面拓展',
  [MATERIAL_ABILITY.REPLACE]: '智能替换',
  [MATERIAL_ABILITY.ERASER]: '智能擦除',
  [MATERIAL_ABILITY.UPSCALE]: '无损放大',
  [MATERIAL_ABILITY.LINE]: '线稿提取',
  [MATERIAL_ABILITY.CROP]: '图像裁剪',
  [MATERIAL_ABILITY.FACE]: '脸部修复',
  [MATERIAL_ABILITY.HAND]: '手部修复',
  [MATERIAL_ABILITY.COLOR_CHANGE]: '服装换色',
  [MATERIAL_ABILITY.SVG]: '转矢量图',
  [MATERIAL_ABILITY.STITCHING]: '无缝排版',
  [MATERIAL_ABILITY.IMAGE_TO_PRINT]: '印花图提取',
  [MATERIAL_ABILITY.TORT]: '侵权风险过滤',
  [MATERIAL_ABILITY.PRINTING_COMPOSITING]: '印花合成',
  [MATERIAL_ABILITY.BLEND]: '元素融合',
  [MATERIAL_ABILITY.POLYPTYCH]: '多联画',
  [MATERIAL_ABILITY.DRESS]: '模特试衣',

  [MATERIAL_ABILITY.BATCH_EDITOR]: '批量编辑',
  [MATERIAL_ABILITY.BATCH_WATERMARK]: '去水印',
  [MATERIAL_ABILITY.BATCH_IMAGE_PROCESSING]: '裁剪压缩',
  [MATERIAL_ABILITY.BATCH_EXPAND]: '扩图',
  [MATERIAL_ABILITY.WORKFLOW]: '工作流',

  [MATERIAL_ABILITY.DIY_COMPOSITING]: '图片合成',
  [MATERIAL_ABILITY.DIY_FULFILLMENT]: '履约图合成',
  [MATERIAL_ABILITY.PET_DRESSUP]: '宠物换装',
};

export const MATERIAL_ABILITY_ICONS = {
  [MATERIAL_ABILITY.BASIC]: 'icon-ic_infrastructure_mode',
  [MATERIAL_ABILITY.TEXT]: 'icon-ic_texttoimg',
  [MATERIAL_ABILITY.TEXT_PRO]: 'icon-ic_texttoimg',
  [MATERIAL_ABILITY.DRAFT]: 'icon-ic_intelligence_draft_roller21',
  [MATERIAL_ABILITY.DRAFT_PRO]: 'icon-ic_intelligence_draft_roller21',
  [MATERIAL_ABILITY.IMAGE]: 'icon-ic_similar_material',
  [MATERIAL_ABILITY.IMAGE_PRO]: 'icon-ic_similar_material',
  [MATERIAL_ABILITY.POSE]: 'icon-ic_intelligence_pose2',
  [MATERIAL_ABILITY.TILED]: 'icon-ic_texttoimg',
  [MATERIAL_ABILITY.TILING]: 'icon-ic_texttoimg',
  [MATERIAL_ABILITY.TRANSPARENT]: 'icon-ic_texttoimg',
  [MATERIAL_ABILITY.POD]: 'icon-ic_infrastructure_mode',
  [MATERIAL_ABILITY.REDRAW]: 'icon-ic_intelligence_draft_roller3',
  [MATERIAL_ABILITY.SEAMLESS]: 'icon-ic_eamless_stitching_jigsaw',
  [MATERIAL_ABILITY.POLYPTYCH]: 'icon-ic_multiple_painting',

  // [MATERIAL_ABILITY.ART_WORD]: 'icon-ic_infrastructure_mode',

  [MATERIAL_ABILITY.BG]: 'icon-ic_product_bgchanger1',
  [MATERIAL_ABILITY.MODEL]: 'icon-ic_aimodel',
  [MATERIAL_ABILITY.FITTING]: 'icon-ic_aiclothes2',
  [MATERIAL_ABILITY.MOCKUP]: 'icon-ic_mockups',

  [MATERIAL_ABILITY.MATTING]: 'icon-ic_intelligence_imagematting1',
  [MATERIAL_ABILITY.ERASER]: 'icon-ic_intelligence_erase',
  [MATERIAL_ABILITY.EXPAND]: 'icon-ic_intelligence_img_expansion',
  [MATERIAL_ABILITY.LINE]: 'icon-ic_intelligence_sketch_handle11',
  [MATERIAL_ABILITY.REPLACE]: 'icon-ic_intelligence_replacement',
  [MATERIAL_ABILITY.UPSCALE]: 'icon-ic_intelligence_draft_improved2',
  [MATERIAL_ABILITY.CROP]: 'icon-ic_cutting1',
  [MATERIAL_ABILITY.FACE]: 'icon-ic_face_restoration',
  [MATERIAL_ABILITY.HAND]: 'icon-ic_hands_restoration',
  [MATERIAL_ABILITY.COLOR_CHANGE]: 'icon-ic_change_color',
  [MATERIAL_ABILITY.SVG]: 'icon-ic_switch_svg',
  [MATERIAL_ABILITY.STITCHING]: 'icon-ic_eamless_stitching_jigsaw',
  [MATERIAL_ABILITY.IMAGE_TO_PRINT]: 'icon-ic_printed_pattern_paved',
  [MATERIAL_ABILITY.TORT]: 'icon-ic_infringement_detection',
  [MATERIAL_ABILITY.PRINTING_COMPOSITING]: 'icon-ic_printing_composite',

  [MATERIAL_ABILITY.BATCH_WATERMARK]: 'icon-ic_remove_watermark',
  [MATERIAL_ABILITY.BATCH_EXPAND]: 'icon-ic_img_expansion',
  [MATERIAL_ABILITY.BATCH_IMAGE_PROCESSING]: 'icon-ic_cutting_compression',
};

export const MATERIAL_ABILITY_GUIDE_URLS = {
  [MATERIAL_ABILITY.BASIC]:
    'https://static.lingvisions.com/public/00ecabc702c1405594728aede98f0c57.png',
  [MATERIAL_ABILITY.TEXT]:
    'https://static.lingvisions.com/public/73aeb262175842d0bbc1f85ef1e10454.png',
  [MATERIAL_ABILITY.TEXT_PRO]:
    'https://static.lingvisions.com/public/73aeb262175842d0bbc1f85ef1e10454.png',
  [MATERIAL_ABILITY.DRAFT]:
    'https://static.lingvisions.com/public/a047c98278514541b440f94617b3a4fa.png',
  [MATERIAL_ABILITY.DRAFT_PRO]:
    'https://static.lingvisions.com/public/a047c98278514541b440f94617b3a4fa.png',
  [MATERIAL_ABILITY.TRANSPARENT]:
    'https://static.lingvisions.com/public/e641d214b1f1473896dcf9a1414c17ca.png',
  [MATERIAL_ABILITY.TILED]:
    'https://static.lingvisions.com/public/8a1f5d701ce748be842218d6d78530e2.png',
  [MATERIAL_ABILITY.POD]:
    'https://static.lingvisions.com/public/dae3a0134393452bb51067f857cc9cb6.png',
  [MATERIAL_ABILITY.IMAGE]:
    'https://static.lingvisions.com/public/d0d1a9a65370494e97e9654c79bd2a15.png',
  [MATERIAL_ABILITY.IMAGE_PRO]:
    'https://static.lingvisions.com/public/d0d1a9a65370494e97e9654c79bd2a15.png',
  [MATERIAL_ABILITY.POSE]:
    'https://static.lingvisions.com/public/061db47195434012b9cb8eccee61609e.png',
  // [MATERIAL_ABILITY.ART_WORD]:
  //   'https://static.lingvisions.com/public/061db47195434012b9cb8eccee61609e.png',

  [MATERIAL_ABILITY.BG]:
    'https://static.lingvisions.com/public/76b1ad11aca34b92aee6ae91fe5f0d8f.png',
  [MATERIAL_ABILITY.MODEL]:
    'https://static.lingvisions.com/public/3ae0c5690d64482b80689e9cac7acdae.png',
  [MATERIAL_ABILITY.FITTING]:
    'https://static.lingvisions.com/public/b7c5070cc5804388b5c12bb38e793d14.png',
  [MATERIAL_ABILITY.MOCKUP]:
    'https://static.lingvisions.com/public/6f5d5c14c2f5469695b076a6454fd37d.png',

  [MATERIAL_ABILITY.MATTING]:
    'https://static.lingvisions.com/public/7e681f0605b84c3ea509f0bf25cc45f9.png',
  [MATERIAL_ABILITY.EXPAND]:
    'https://static.lingvisions.com/public/6cde8723bf0842a6b7e225c4a1f5fac0.png',
  [MATERIAL_ABILITY.REPLACE]:
    'https://static.lingvisions.com/public/c136621b6467426bbb64ad3765e788f2.png',
  [MATERIAL_ABILITY.ERASER]:
    'https://static.lingvisions.com/public/c64922c06e0543588a8621ea741b55c8.png',
  [MATERIAL_ABILITY.UPSCALE]:
    'https://static.lingvisions.com/public/bafc9e8f476e414aa9d3ddb91da9dd09.png',
  [MATERIAL_ABILITY.LINE]:
    'https://static.lingvisions.com/public/19787bdb39d14572a630eec9b6582876.png',
  [MATERIAL_ABILITY.CROP]:
    'https://static.lingvisions.com/public/83d841bb0aa748fbae864a3e60afc78e.png',
  [MATERIAL_ABILITY.FACE]:
    'https://static.lingvisions.com/public/578f9a4f52f643d8814fa664117c0cd2.png',
  [MATERIAL_ABILITY.HAND]:
    'https://static.lingvisions.com/public/eb6a7a84c16043959b9f9824d2d89f28.png',
  [MATERIAL_ABILITY.COLOR_CHANGE]:
    'https://static.lingvisions.com/public/49b9b05a57e741cf9d6f8e55aea67351.png',

  [MATERIAL_ABILITY.SVG]:
    'https://static.lingvisions.com/public/15e2e0c40fb24ea99bec934dcd4cb6c0.png',
  [MATERIAL_ABILITY.STITCHING]:
    'https://static.lingvisions.com/public/14316881776748afa40ec3fb1ca10f56.png',
};

export const MATERIAL_ABILITY_SIMPLE_ICONS = {
  [MATERIAL_ABILITY.BASIC]: 'icon-ic_infrastructure_mode1',
  [MATERIAL_ABILITY.TEXT]: 'icon-ic_texttoimg1',
  [MATERIAL_ABILITY.DRAFT]: 'icon-ic_intelligence_draft_roller3',
  [MATERIAL_ABILITY.IMAGE]: 'icon-ic_similar_material1',
  [MATERIAL_ABILITY.IMAGE_PRO]: 'icon-ic_similar_material1',
  [MATERIAL_ABILITY.WORKFLOW]: 'icon-ic_custom_workflow',

  [MATERIAL_ABILITY.POSE]: 'icon-ic_intelligence_pose1',
  [MATERIAL_ABILITY.TILED]: 'icon-ic_eamless_stitching_jigsaw',
  [MATERIAL_ABILITY.TILING]: 'icon-ic_eamless_stitching_jigsaw',
  [MATERIAL_ABILITY.TRANSPARENT]: 'icon-ic_texttoimg1',
  [MATERIAL_ABILITY.POD]: 'icon-ic_infrastructure_mode1',

  [MATERIAL_ABILITY.BG]: 'icon-ic_product_bgchanger3',
  [MATERIAL_ABILITY.MODEL]: 'icon-ic_aimodel1',
  [MATERIAL_ABILITY.FITTING]: 'icon-ic_aiclothes',
  [MATERIAL_ABILITY.POLYPTYCH]: 'icon-ic_multiple_painting',

  [MATERIAL_ABILITY.MATTING]: 'icon-ic_intelligence_imagematting',
  [MATERIAL_ABILITY.MULTI_SIZE]: 'icon-duoxingzhuangduochicun',
  [MATERIAL_ABILITY.STYLE_REFERENCE]: 'icon-fenggecankao',
  [MATERIAL_ABILITY.EXPAND]: 'icon-ic_img_expansion',
  [MATERIAL_ABILITY.REPLACE]: 'icon-ic_intelligence_replacement_l',
  [MATERIAL_ABILITY.PART_REPLACE]: 'icon-ic_intelligence_replacement_l',
  [MATERIAL_ABILITY.BLEND]: 'icon-yuansuronghe',
  [MATERIAL_ABILITY.ERASER]: 'icon-ic_intelligence_eraser_tool',
  [MATERIAL_ABILITY.DRESS]: 'icon-moteshiyi',

  [MATERIAL_ABILITY.UPSCALE]: 'icon-ic_intelligence_draft_improved1',
  [MATERIAL_ABILITY.LINE]: 'icon-ic_intelligence_sketch_handle1',
  [MATERIAL_ABILITY.CROP]: 'icon-ic_cutting',
  // [MATERIAL_ABILITY.STITCHING]: 'icon-ic_eamless_stitching_jigsaw',
  [MATERIAL_ABILITY.FACE]: 'icon-ic_face_restoration1',
  [MATERIAL_ABILITY.HAND]: 'icon-ic_hands_restoration1',

  [MATERIAL_ABILITY.COLOR_CHANGE]: 'icon-ic_change_color1',
  [MATERIAL_ABILITY.SVG]: 'icon-ic_switch_svg2',
  [MATERIAL_ABILITY.MOCKUP]: 'icon-ic_mockups1',
  [MATERIAL_ABILITY.TITLE]: 'icon-ic_title_extraction',
  [MATERIAL_ABILITY.CRAWLING]: 'icon-ic_data_collection',
  [MATERIAL_ABILITY.DETECT]: 'icon-ic_product_pictures_detect',
  [MATERIAL_ABILITY.IMAGE_TO_PRINT]: 'icon-ic_printed_pattern_paved',
  [MATERIAL_ABILITY.TORT]: 'icon-ic_infringement_detection',
  [MATERIAL_ABILITY.PRINTING_COMPOSITING]: 'icon-ic_printing_composite',
  [MATERIAL_ABILITY.REDRAW]: 'icon-ic_intelligence_draft_roller3',
  [MATERIAL_ABILITY.SEAMLESS]: 'icon-ic_eamless_stitching_jigsaw',
  [MATERIAL_ABILITY.IMAGE_PROCESSING]: 'icon-ic_cutting_compression',
  [MATERIAL_ABILITY.VIDEO]: 'icon-ic_video_generate',
  [MATERIAL_ABILITY.BATCH_EDITOR]: 'icon-ic_batch_edit',
  [MATERIAL_ABILITY.CUT_PIECES]: 'icon-caibiandingweitumoban',
  [MATERIAL_ABILITY.BATCH_WATERMARK]: 'icon-ic_remove_watermark',
  [MATERIAL_ABILITY.BATCH_EXPAND]: 'icon-ic_img_expansion',
  [MATERIAL_ABILITY.BATCH_IMAGE_PROCESSING]: 'icon-ic_cutting_compression',

  [MATERIAL_ABILITY.DIY_COMPOSITING]: 'icon-ic_intelligence_reference_produce2',
  [MATERIAL_ABILITY.DIY_FULFILLMENT]: 'icon-a-ic_Performancesynthesis1',
  [MATERIAL_ABILITY.PET_DRESSUP]: 'icon-chongwuhuanzhuang',
};

export const MATERIAL_EDITOR_TOOLS = MATERIAL_EDIT_ABILITIES.filter(
  (v) =>
    ![
      MATERIAL_ABILITY.EDITOR,
      MATERIAL_ABILITY.BATCH_MATTING,
      MATERIAL_ABILITY.FACE,
      MATERIAL_ABILITY.HAND,
      MATERIAL_ABILITY.COLOR_CHANGE,
      MATERIAL_ABILITY.SVG,
      MATERIAL_ABILITY.STITCHING,
    ].includes(v)
).map((v) => ({
  title: MATERIAL_ABILITY_NAMES[v],
  icon: MATERIAL_ABILITY_SIMPLE_ICONS[v],
  code: v,
}));

export const IMAGE_REFERENCES = [
  {
    title: '整体',
    value: 'all',
    image: 'https://static.lingvisions.com/public/869ebcf53ad24fb8af5af3d33cccc1e7.png',
  },
  {
    title: '构图',
    value: 'composition',
    image: 'https://static.lingvisions.com/public/3f03243c63b14e10af2881b7fcac1ce5.png',
  },
  {
    title: '风格',
    value: 'style',
    image: 'https://static.lingvisions.com/public/b3011a9708cc42039bda29e585861bc2.png',
  },
  {
    title: '人脸',
    value: 'face',
    image: 'https://static.lingvisions.com/public/0ccc677652bc4a09850a3aef1de5b028.png',
  },
];
